import TextBox from "../../componets/TextBox";
import designData from "../../data/projectOutsourcingBenefits.json";

export default function Section5() {
  return (
    <div className="Section5">
      <div className="w-[90%] my-[24px] md:mb-0 md:w-[61%] mx-auto text-center">
        <h2 className="mx-auto text-center text-[24px] leading-[32px] md:text-[34px] font-bold md:leading-[41px] text-[#151515] my-[0.67em]">
          Why Choose Mean3 for IT Project Outsourcing
        </h2>
      </div>

      <TextBox
        data={designData}
        containerStyle="text-center p-[2%_0%_4%_0%]"
        oddStyle="bg-[#E42E35] text-white"
        evenStyle="bg-[#f5f5f5] text-[#373737]"
        boxStyle="md:p-[10px] xs:w-[33%] md:w-[26%] w-full"
        titleStyle="text-[18px] md:text-[20px] font-bold leading-[23px] my-[0.67em]"
        imgStyle="w-[26%] mx-auto"
      />
    </div>
  );
}
